"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roleDetailsKeys = void 0;
exports.roleDetailsKeys = ["regional-manager", "senior-regional-manager"];
//# sourceMappingURL=RoleDetails.js.map